import { render, staticRenderFns } from "./BnftGiverScroll.vue?vue&type=template&id=32acd39b&scoped=true&"
import script from "./BnftGiverScroll.vue?vue&type=script&lang=js&"
export * from "./BnftGiverScroll.vue?vue&type=script&lang=js&"
import style0 from "./BnftGiverScroll.vue?vue&type=style&index=0&id=32acd39b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32acd39b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VAvatar,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VVirtualScroll})
